import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalComponent } from '../../shared/components/modals/modal/modal.component';
import { EventClient, FileClient, RubricClient } from 'src/app/services/apis/web-api-client';
import { FileService } from 'src/app/services/file.service';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
  activeSlideIndex = 1;
  isLoading = true;
  modalRef: BsModalRef;
  itemsPerSlide = 3;
  itemsPerSlide1 = 1;
  activeRubric;
  news = [];
  rubrics = [];
  events = [];
  countOfSlides = 0;

  constructor(
    private modalService: BsModalService,
    private datepipe: DatePipe,
    private eventService: EventClient,
    private rubricService: RubricClient,
    private fileService: FileService,
  ) { }

  openModal() {
    this.modalRef = this.modalService.show(ModalComponent);
  }

  ngOnInit(): void {
    forkJoin({
      rubrics: this.rubricService.getAll(),
      events: this.eventService.getAll()
    }).subscribe(({ rubrics, events }) => {
      this.rubrics = rubrics;
      this.news = events.filter(x => x.rubricId != null);
      this.events = events.filter(x => x.isEvent === true);
      this.adjustsItemsPerSlide();
      this.isLoading = false;
      this.countOfSlides = this.events.length
    })
    // this.rubricService.getAll().subscribe(ru => {
    //   this.rubrics = ru;
    //   this.eventService.getAll().subscribe(data => {
    //     this.news = data.filter(x => x.rubricId != null && !x.isEvent);
    //     //Заранее прошу прощения за эту грязь (очень неприятно портить нормальный код но приходится во имя скорости. И да постигнет меня праведный гнев того кто это будет править.). 😥
    //     // this.events = data.filter(x => x.rubric != null).filter(x => x.rubric.name == "Мероприятия");
    //     this.events = data.filter(x => x.isEvent === true);
    //     this.adjustsItemsPerSlide();
    //     this.isLoading = false;
    //     this.countOfSlides = this.events.length;
    //   });
    // })
  }

  private innerWidth: number;
  private mobileBreakpoint = 769;

  slideChange(event: number) {
    this.activeSlideIndex = event + 1;
  }

  private adjustsItemsPerSlide() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < this.mobileBreakpoint) {
      this.itemsPerSlide = 1;
      this.itemsPerSlide1 = 1;
    } else {
      this.itemsPerSlide = 3;
      this.itemsPerSlide1 = 1;
    }
  }

  getImage(link) {
    return this.fileService.getDownloadUrl(link);
  }

  filterNews(rubric) {
    this.eventService.getAll().subscribe(data => {
      this.news = data.filter(x => x.rubricId != null).filter(x => x.rubricId == rubric);
      this.adjustsItemsPerSlide();
      this.isLoading = false;
    })
  }
  ClearFilterNews() {
    this.eventService.getAll().subscribe(data => {
      this.news = data;
      this.adjustsItemsPerSlide();
    })
  }

  formatDate(date: Date) {
    return this.datepipe.transform(date, 'dd/MM/yyyy')
  }

  getColor(i) {
    if (i % 3 == 0) return "card-type ct1";
    if (i % 3 == 1) return "card-type ct2";
    if (i % 3 == 2) return "card-type ct3";
  }
  getColor2(i) {
    if (i % 3 == 0) return "cf1";
    if (i % 3 == 1) return "cf2";
    if (i % 3 == 2) return "cf3";
  }
}
